/* unplugin-vue-components disabled */import { render } from "./Home.vue?vue&type=template&id=23806422&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=23806422&lang=scss&scope=true"
import "./Home.vue?vue&type=style&index=1&id=23806422&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23806422"]])

export default __exports__